import { PATH_BACKEND } from 'configs/routes/pathsBackend';
import { CreateTaskRequestDTO, TaskResponseDTO } from 'typings/dto/task';
import IModelActionsService from './IModelActionsService';
import ModelActionsService from './ModelActionsService';

export default class TaskActionsService
  extends ModelActionsService<Task, CreateTaskRequestDTO, TaskResponseDTO>
  implements IModelActionsService<Task, CreateTaskRequestDTO, TaskResponseDTO>
{
  protected getModelApiRootPath = (dto: { orderId: string }) => {
    return PATH_BACKEND.order.root + '/' + dto.orderId + '/' + super.getModelApiRootPath(dto);
  };
}
